enum VideoOutputStatus {
  INITIAL = 'INITIAL',
  VIDEO_REQUEST = 'VIDEO_REQUEST',
  VIDEO_ERROR = 'VIDEO_ERROR',
  VIDEO_READY = 'VIDEO_READY',
}

interface IVideoOutput {
  videoUrl: string;
  thumbnailUrl: string;
  downloadUrl: string;
}

interface IVideoMeta {
  resultVideoId: string;
  videoSessionId: number | null;
  progressId?: string;
  startTime?: number;
}

export { IVideoMeta, IVideoOutput, VideoOutputStatus };
